define('components/date-picker',['jquery', 'pikaday'], function($, Pikaday) {

    var i18n;
    var isGermanLang = companyInfo.lang === "de";

    if (isGermanLang) {
        i18n = {
            previousMonth : 'vorheriger monat',
            nextMonth     : 'nächsten monat',
            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
            weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
            weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
        };
    } else {
        i18n = {
            previousMonth : 'Previous month',
            nextMonth     : 'Next month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        };
    }

    var handleChange  = (function () {
        var skip = false;
        function skipNextChange() {
            skip = true;
        }
        function handle(e) {
            if (skip) {
                skip = false;
                e.stopImmediatePropagation();
            } else {
                var input = $(this);
                var regex = /^(\d{1,2})[\.\-\/](\d{1,2})[\.\-\/](\d{4})$/;
                var m = e.target.value.match(regex);
                var validDate = m && new Date(m[3] + '-' + m[2] + '-' + m[1]).getDate();
                var parentDiv = input.parent().parent();

                // If date is invalid
                if (!validDate && e.target.value !== '') {
                    e.stopImmediatePropagation();
                    var hasError = parentDiv.find('.pikaday-error').length !== 0;
                    var errorText = isGermanLang ? ' ist kein gültiges Datum' : ' is incorrect date';
                    // If no errors are currently shown, add error paragraph and remove the input value
                    if (!hasError) {
                        input.parent().after('<p class="pikaday-error">' + e.target.value + errorText + '</p>');
                        input.val('');
                    } else {
                        // if error is already shown, update the text
                        parentDiv.find('.pikaday-error').text(e.target.value + errorText);
                    }
                    // Add prev date as input value, if there is no prev date, input will be cleared
                    var prevValue = input.data('prev-date');
                    e.target.value = formatDate(prevValue);
                } else {
                    // if date is valid, remove error and add the date to prev date attribute.
                    input.data('prev-date', e.target.value);
                    parentDiv.find('.pikaday-error').remove();
                }
            }
        }

        handle.skipNextChange = skipNextChange;

        return handle;
    })();

    function formatDate (value) {
        var separator = isGermanLang ? '.' : '/';
        var datePart = value.match(/^((\d{4})[\.\-\/](\d{1,2})[\.\-\/](\d{1,2}))$|^((\d{1,2})[\.\-\/](\d{1,2})[\.\-\/](\d{4}))$/);
        if (!datePart) {
            return '';
        }
        datePart = datePart.filter(function(d) {
            return d;
        });
        var year, month, day;
        if (datePart[4].length === 4) {
            year = datePart[4].substring(0, 4);
            month = datePart[3];
            day = datePart[2];
        }
        if (datePart[2].length === 4) {
            year = datePart[2].substring(0, 4);
            month = datePart[3];
            day = datePart[4];
        }

        return day + separator + month + separator + year;
    }

    function blockChangePropagation(e){
        e.stopImmediatePropagation();
    }

    function checkIfIE() {
        var testInput = document.createElement('input');
        testInput.setAttribute('type', 'date');
        return testInput.type === 'text';
    }

    $.extend(companyInfo.decorators, {
        'date': function(e) {
            var input = this;
            var $input = $(input);
            var isTextInput = $input.attr('type') === 'text';
            var picker;
            var isIE = checkIfIE();
            var defaultPikaday = $input.data('default-input');

            if (isIE && defaultPikaday) {
                $input.on('change', blockChangePropagation);
                var date = input.value;
                picker = new Pikaday({
                    field: input,
                    minDate: input.getAttribute('min') && new Date(input.getAttribute('min')),
                    maxDate: input.getAttribute('max') && new Date(input.getAttribute('max')),
                    i18n: i18n
                });
                picker.setDate(date);
                $input.off('change',blockChangePropagation);
                return;
            }

            if (isTextInput) {
                handleChange.skipNextChange();
                $input.on('change', handleChange);
                var thisDate = input.value;
                var yearRange = [
                  input.dataset.minyear || '1900',
                  input.dataset.maxyear || new Date().getFullYear()
                ];
                picker = new Pikaday({
                    field: input,
                    format: isGermanLang ? 'DD.MM.YYYY' : 'DD/MM/YYYY',
                    minDate: input.getAttribute('min') && new Date(input.getAttribute('min')),
                    maxDate: input.getAttribute('max') && new Date(input.getAttribute('max')),
                    defaultDate: input.dataset.defaultdate && new Date(input.dataset.defaultdate),
                    yearRange: yearRange,
                    i18n: i18n,
                    theme: 'custom-pikaday',
                });
                handleChange.skipNextChange();
                $input.data('prev-date', thisDate);
                picker.setDate(thisDate);
            }
        }
    });

});
